define('@brightspark/sparkling-observable-js-property-changed-ext', ["@brightspark/sparkling-observable-js"], function(Observable){

    var _defaults = {
        get: true,
        set: true
    };

    /**
     * Publish or subscribe 'propertyChanged' event
     * publish always like this:
     * propertyChanged("propName", val, prevVal)
     *
     * subscribe has two alternatives
     * ALT1: subscribe to all propertyChanged events
     *       propertyChanged(function (propName, val, prevVal) { ... })
     * ALT2: subscribe to certain propertyChanged event
     *       propertyChanged("propName", function (val, prevVal) { ... })
     */
    Observable.prototype.propertyChanged = function () {

        var args = arguments;
        var handler = args[0];

        // ALT1
        if (typeof handler === "function") {
            this.subscribe("propertyChanged", handler);
            return this;
        }

        var propertyName = args[0];
        var handler = args[1];

        // ALT2
        if (args.length == 2 && typeof propertyName === "string" && typeof handler === "function") {
            this.subscribe("propertyChanged-" + propertyName, handler);
            return this;
        }

        // clone args
        var l = args.length;
        var namedPropertyChangedArgs = new Array(l);
        for (var i = 0; i < l; i++) {
            namedPropertyChangedArgs[i] = args[i];
        }

        // publish for ALT1
        var propChanged = [].unshift.call(args, "propertyChanged");
        this.publish.apply(this, args);

        // publish for ALT2
        var propertyName = [].shift.call(namedPropertyChangedArgs);
        var namedPropertyChangedEventName = "propertyChanged-" + propertyName;
        [].unshift.call(namedPropertyChangedArgs, namedPropertyChangedEventName);
        this.publish.apply(this, namedPropertyChangedArgs);

        return this;
    };

    /**
     * Add a new observable property
     * @param {object} backingFields - object that holds the backing field
     * @param {string} propertyName - name of the new property
     * @param {object} settings - property definition settings { get: true, set: false }
     */
    Observable.prototype.defineObservableProperty = function (backingFields, propertyName, settings) {
        var prop = new ObservableProperty(this, backingFields, propertyName, settings);
        Object.defineProperty(this, propertyName, prop);
    };

    /**
     * Add multiple observable properties
     * @param {object} backingFields - its fields are used as property names and values
     * @param {object} settings - property definition settings for fields in backingFields
     *    Example:
     *        var settings = {
     *            isVisible: { get: true, set: false },
     *            isActive: { get: false }
     *        }
     */
    Observable.prototype.defineObservableProperties = function (backingFields, settings) {
        settings = settings || {};
        for (var propertyName in backingFields) {
            if (backingFields.hasOwnProperty(propertyName)) {
                this.defineObservableProperty(backingFields, propertyName, settings[propertyName]);
            }
        }
    };

    /**
     * Create observable property definition
     * @param {object} obj - observable object
	 * @param {object} backingFields - object that holds the backing field
     * @param {string} propertyName - name of the new property
     * @param {object} settings - property definition settings { get: true, set: false }
     */
    var ObservableProperty = function (obj, backingFields, propertyName, settings) {
        var currentSettings = buildSettings(settings);

		var _set = function ObservableSet(val) {
			var prevVal = backingFields[propertyName];
			if (val === prevVal) {
				return;
			}

			backingFields[propertyName] = val;
			obj.propertyChanged(propertyName, val, prevVal);
		};

        if (currentSettings.get === true) {
            this.get = function () {
                return backingFields[propertyName];
            };
        }

        if (currentSettings.set === true) {
            this.set = _set;
        }
		else if (typeof settings.set === "function") {
			this.set = function ObservableSet(val) {
				settings.set(val, _set);
			}
		}

        return this;
    };

    /**
     * Combines overriden setting values with defaults
     * @param {object} overrides - object with values to override default settings
     * @returns {object} - object with final settings values (overriden or default)
     */
    var buildSettings = function (overrides) {
        overrides = overrides || {};
        var res = {};
        for (var i in _defaults) {
            if (_defaults.hasOwnProperty(i)) {
                res[i] = coalesce(overrides[i], _defaults[i]);
            }
        }
        return res;
    };

    /**
     * Returns first value of arguments which is not null or undefined
     */
    var coalesce = function() {

        for (var i = 0; i < arguments.length; i++) {
            var arg = arguments[i];
            if (arg !== null && typeof (arg) !== "undefined") {
                return arg;
            }
        }

        return null;
    };

    return Observable;

});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@brightspark/sparkling-observable-js-property-changed-ext/sparkling-observable-property-changed-ext.js
// module id = 508
// module chunks = 10